var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExploreRotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Explore",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "solid/repeat-alt",
    style: {
      mixBlendMode: "overlay"
    },
    fill: "#FCFCFC"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M453.953334,193.885833 C463.916667,212.723333 469.499167,234.219167 469.330001,257.010833 C468.782501,330.470834 408.133334,389.333334 334.67,389.333334 L202.666667,389.333334 L202.666667,428.9125 C202.666667,447.641667 180.8525,455.8025 168.524166,443.475 L101.8575,376.808334 C94.0474996,368.9975 94.0474996,356.334167 101.8575,348.524167 L168.524166,281.8575 C181.115,269.266667 202.666667,278.238333 202.666667,296 L202.666667,336 L335.0625,336 C379.0725,336 415.541667,300.848333 415.995834,256.84 C416.125,244.3025 413.354167,232.413333 408.314167,221.801667 C404.679167,214.1475 406.296667,205.031667 412.314167,199.065 C416.268334,195.143333 419.515,191.935833 422.210834,189.243333 C431.684167,179.783333 447.693334,182.050833 453.953334,193.885833 Z M96.0041663,255.16 C96.4583329,211.151667 132.9275,176 176.9375,176 L309.333333,176 L309.333333,215.5875 C309.333333,234.2325 331.100834,242.514167 343.475834,230.141667 L410.1425,163.475 C417.9525,155.664166 417.9525,143.000833 410.1425,135.190833 L343.475834,68.5241662 C331.011667,56.0641662 309.333333,64.5466662 309.333333,83.1208329 L309.333333,122.666666 L177.33,122.666666 C103.866666,122.666666 43.2174995,181.529166 42.6708328,254.99 C42.5008328,277.781667 48.0833328,299.2775 58.0474995,318.115 C64.3074995,329.95 80.3166662,332.2175 89.7899996,322.756667 C92.4858329,320.064167 95.7316663,316.856667 99.6866663,312.935 C105.703333,306.968333 107.321666,297.853333 103.686666,290.198333 C98.6458329,279.585833 95.8749996,267.6975 96.0041663,255.16 Z",
    id: "repeat-alt"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExploreRotation);
export default __webpack_public_path__ + "static/media/iconExploreRotation.b204043c.svg";
export { ForwardRef as ReactComponent };